<div class="hr-separator"><hr></div>
<nz-spin [nzSpinning]="isLoading"></nz-spin>

<ng-container *ngIf="!isLoading && data">
  <div class="row">
    <div class="col col-lg-12">
      <table class="table table-borderless">
        <tr>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Failure Mode: <strong>{{ data?.failure_mode | nullAsWhatever : '-' }}</strong></td>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Fault Code: <strong>{{ data?.fault_code | nullAsWhatever : '-' }}</strong></td>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Status: <strong>{{ data?.status | nullAsWhatever : '-' }}</strong></td>
        </tr>
        <tr>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Created Date: <strong>{{ data?.created_date | niceDate : '-' : true }}</strong></td>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Closed Date: <strong>{{ data?.closed_date | niceDate : '-' : true }}</strong></td>
          <td class="fs-12 pt-1 pb-1 px-0 pe-0">Type: <strong>{{ data?.type | nullAsWhatever : '-' }}</strong></td>
        </tr>
      </table>
    </div>

    <div class="col col-lg-12 mb-3">
      TagNames:
      <ng-container *ngFor="let tag of data.tags; let i = index">
        <span class="clickable" (click)="onDataCardDrawerOpen(tag)">
          {{ tag }}
        </span>
        <ng-container *ngIf="i + 1 < data.tags.length">, </ng-container>
      </ng-container>
    </div>

    <div class="col col-lg-12">
      <p class="mb-1">{{ data?.description }}</p>

      <ng-container *ngIf="hasReportRepairDescription()">
        <p class="mb-1">{{ data?.repair_report_description }}</p>
      </ng-container>
    </div>

  </div>
</ng-container>
